import { PaginateParams, useQuery } from './useQuery';
import axios from 'axios';
import { CacheId, useCache } from './useCache';
import { CacheNames } from '../types/cache.enums';
import { Concept } from '../types/concept.types';

type GetConceptResponse = Concept;
type GetConceptsResponse = Array<Concept>;
type GetConceptsParams = PaginateParams & {
  ids?: string[];
  recording?: boolean;
  webinar?: boolean;
  active?: boolean;
};

type Options = {
  fields?: Record<string, 1 | 0>;
  with?: Array<'page' | 'cycles'>;
};

const cacheName = CacheNames.CONCEPTS;

export function getConcept(
  conceptId: string,
  options: Options = {}
): Promise<GetConceptResponse> {
  const cacheId: CacheId = [cacheName, conceptId, options];
  const { result } = useQuery<GetConceptResponse>(cacheId, () =>
    axios
      .get<GetConceptResponse>('/api/courses/', {
        params: { id: conceptId, ...options },
      })
      .then((result) => result.data)
  );

  return result;
}

export function getConcepts(
  params: GetConceptsParams = {},
  options: Options = {}
): Promise<GetConceptsResponse> {
  const cacheId: CacheId = [cacheName, params, options];
  const mappedParams = {
    ...params,
    ...(params.ids && { ids: params.ids.join(',') }),
    ...(options.with && { with: options.with.join(',') }),
  };

  const { result } = useQuery<GetConceptsResponse>(cacheId, () =>
    axios
      .get<GetConceptsResponse>('/api/courses/', {
        params: mappedParams,
      })
      .then((result) => result.data)
  );

  return result;
}

export function reloadConcepts(
  params: GetConceptsParams = {},
  options: Options = {}
): Promise<GetConceptsResponse> {
  useCache().clearCache(cacheName);

  return getConcepts(params, options);
}
